const prefix = 'COMPANY_ADMIN_USERS/';
export const COMPANY_ADMIN_USERS_LIST_TAG = `${prefix}LIST`;

export const COMPANY_ADMIN_USERS_PERMISSIONS_TAG = `${prefix}USER_PERMISSIONS`;

export const COMPANY_ADMIN_COMPANIES_DETAILS_TAG = `${prefix}COMPANY_ADMIN_COMPANIES_DETAILS`;

export const COMPANY_ADMIN_USERS_USER_DETAIL_TAG = `${prefix}USER_DETAIL`;
